import * as React from 'react'

export function LightdirectionDiffusedLight(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.293 13.606a.999.999 0 010-1.414l7.899-7.899a.999.999 0 111.414 1.414l-7.899 7.9a.999.999 0 01-1.414 0zm8.855 13.668a.999.999 0 010-1.414l12.728-12.728a1 1 0 011.414 1.414L14.562 27.274a.999.999 0 01-1.414 0zm5.246.433a.999.999 0 010-1.414l7.899-7.899a.999.999 0 111.414 1.414l-7.9 7.899a.999.999 0 01-1.413 0zM8.905 25.86a.999.999 0 010-1.414L24.462 8.89a1 1 0 011.414 1.415L10.32 25.86a1 1 0 01-1.415 0zm-2.828-2.828a.999.999 0 010-1.414L21.634 6.061a1 1 0 011.414 1.414L7.491 23.032a.999.999 0 01-1.414 0zM4.663 18.79a.999.999 0 010-1.414L17.391 4.647a1 1 0 011.414 1.414L6.077 18.79a.999.999 0 01-1.414 0z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
